<div class="int-card">
    <mat-card class="reset-card" [ngClass]="{'padding-bottom': !showPrerequisites}">
        <form [formGroup]="resetForm">
            <img (click)="cancel()" class="arrow-left" src="/assets/account/arrow-left.svg" />
            <h1 class="title-reset">{{ 'account.reset.title' | translate }}</h1>
            <p class="subtitle-reset">{{ 'account.reset.instructions' | translate }}</p>

            <!-- Just to don't show the autocomplete in some browsers -->
            <input class="hidden" type="text" style="display: none!important; visibility: hidden!important;" />
            <input class="hidden" type="password" style="display: none!important; visibility: hidden!important;" />
    
            <div class="card-form">
                <div class="input-wrapper">
                    <input class="input" formControlName="code" type="number" [placeholder]="'account.reset.code' | translate" required>
                    <div class="not-match absolute" *ngIf="resetForm?.controls?.code?.invalid && (resetForm?.controls?.code?.touched || resetForm?.value?.password)">
                        {{ 'account.reset.hint.code' | translate }}
                    </div>
                </div>

                <div class="input-wrapper">
                    <div class="input-icon reset">
                        <input class="input" formControlName="password" [type]="showNewPassword ? 'text' : 'password'"
                            [placeholder]="'account.reset.newPass' | translate" appBlockPaste minlength="8" maxlength="20" required
                            (input)="validatePassword()">
                        <mat-icon (click)="showNewPassword = !showNewPassword">{{ showNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </div>
                    <div class="not-match absolute" *ngIf="(resetForm?.controls?.password?.invalid && resetForm?.controls?.password?.touched)">
                        {{ 'account.reset.hint.password' | translate }}
                    </div>
                </div>
                <div class="prerequisites-instructions" [ngClass]="{'margin-top': showPrerequisites}">
                    <mat-icon class="help" [ngClass]="{ 'up' : (!showPrerequisites && resetForm?.controls?.password?.invalid && resetForm?.controls?.password?.touched)}" *ngIf="!showPrerequisites"
                        (click)="showPrerequisites = !showPrerequisites; validatePassword()">info</mat-icon>
                    <span class="title" *ngIf="showPrerequisites">{{ 'account.reset.prerequisites.title' | translate }}</span>
                    <div class="password-help" *ngIf="showPrerequisites">
                        <mat-icon class="hide-help" (click)="showPrerequisites = !showPrerequisites;">keyboard_arrow_up</mat-icon>
                        <div class="left">
                            <div class="password-hint">
                                <mat-icon matPrefix class="{{ hasMinChars ? 'check' : 'notCheck' }}">done</mat-icon>
                                <span>{{ 'account.reset.prerequisites.long' | translate }}</span>
                            </div>
                            <div class="password-hint">
                                <mat-icon matPrefix class="{{ hasLowerCase ? 'check' : 'notCheck' }}">done</mat-icon>
                                <span>{{ 'account.reset.prerequisites.lower' | translate }}</span>
                            </div>
                            <div class="password-hint">
                                <mat-icon matPrefix class="{{ hasUpperCase ? 'check' : 'notCheck' }}">done</mat-icon>
                                <span>{{ 'account.reset.prerequisites.upper' | translate }}</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="password-hint">
                                <mat-icon matPrefix class="{{ hasNumber ? 'check' : 'notCheck' }}">done</mat-icon>
                                <span>{{ 'account.reset.prerequisites.number' | translate }}</span>
                            </div>
                            <div class="password-hint">
                                <mat-icon matPrefix class="{{ hasSpecialChar ? 'check' : 'notCheck' }}">done</mat-icon>
                                <span>{{ 'account.reset.prerequisites.special' | translate }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input-wrapper">
                    <div class="input-icon reset">
                        <input class="input" formControlName="confirmPassword" [type]="showRepeatedPassword ? 'text' : 'password'"
                            (input)="matchPass()" [placeholder]="'account.reset.repeatPass' | translate" appBlockPaste minlength="8" maxlength="20" required>
                        <mat-icon (click)="showRepeatedPassword = !showRepeatedPassword">{{ showRepeatedPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </div>
                    <div class="not-match absolute" *ngIf="!match || resetForm?.controls?.confirmPassword?.invalid
                        && resetForm?.controls?.confirmPassword?.touched && resetForm?.value?.confirmPassword">
                        {{ 'account.reset.hint.notMatch' | translate }}
                    </div>
                </div>
        
                <div class="buttons no-margin">
                    <button [disabled]="loading || resetForm.invalid" mat-flat-button class="btn default reset-button" (click)="reset()">{{ 'button.reset' | translate }}</button>
                </div>
            </div>
        </form>
    </mat-card>
</div>
<mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
